export class UpdateOrganizationLocaleDto {
    id: string;
    locale: string;
}
